import React from 'react';
import { Redirect } from 'wouter';

import Route from '../common/components/Route';
import Clients from '../clients/table/Clients';
import Client from '../clients/detail/Client';
import Statistics from '../statistics/Statistics';
import Documentation from '../documentation/Documentation';
import Authentication from '../authentication/Authentication';
import Settings from '../settings/Settings';

function FbRoutes() {
  return (
    <>
      <Route path='/' renderComponent={() => <Redirect to='/clients' />} />
      <Route path='/authentication' renderComponent={() => <Authentication />} />
      <Route path='/clients' renderComponent={() => <Clients />} />
      <Route path='/clients/:clientId' renderComponent={(params) => <Client clientId={params.clientId} />} />
      <Route path='/statistics' renderComponent={() => <Statistics />} />
      <Route path='/documentation' renderComponent={() => <Documentation />} />
      <Route path='/settings' renderComponent={() => <Settings />} />
    </>
  );
}

export default FbRoutes;
